import SkeletonBlock from "ui/Skeleton/components/SkeletonBlock/SkeletonBlock";

import { BLACK, PRODUCT_PREVIEW_SHADOW, WHITE } from "constants/variables";

const HorizontalSmallSkeleton = () => (
  <div
    style={{
      background: WHITE,
      boxShadow: PRODUCT_PREVIEW_SHADOW,
      borderRadius: "10px",
      padding: "10px",
      display: "flex",
    }}
  >
    <SkeletonBlock
      width="118px"
      height="118px"
      style={{
        background: `rgba(${BLACK}, 0.07)`,
        borderRadius: "10px",
      }}
    />
    <div
      style={{
        width: "calc(100% - 118px)",
        marginLeft: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
        }}
      >
        <SkeletonBlock
          width="100%"
          height="40px"
          style={{
            minWidth: "143px",
            background: `rgba(${BLACK}, 0.07)`,
            borderRadius: "10px",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
        }}
      >
        <SkeletonBlock
          width="70px"
          height="25px"
          style={{
            background: `rgba(${BLACK}, 0.07)`,
            borderRadius: "10px",
          }}
        />
        <SkeletonBlock
          width="40px"
          height="40px"
          style={{
            borderRadius: "20px",
            background: `rgba(${BLACK}, 0.07)`,
          }}
        />
      </div>
    </div>
  </div>
);

export default HorizontalSmallSkeleton;
